const FENCED_CODE_PATTERN = /(```[\s\S]*?```|~~~[\s\S]*?~~~)/g
const HIGHLIGHT_PATTERN = /==([^=\n](?:.*?[^=\n])?)==/g

function transformOutsideFencedCode(
  markdown: string,
  transform: (part: string) => string,
): string {
  return markdown
    .split(FENCED_CODE_PATTERN)
    .map((part, index) =>
      index % 2 === 1
        ? part
        : transform(part),
    )
    .join('')
}

/** Expand the portable `==text==` highlight extension outside fenced code. */
export function expandMarkdownHighlights(markdown: string, markClassName?: string): string {
  const classAttribute = markClassName ? ` class="${markClassName}"` : ''
  return transformOutsideFencedCode(
    markdown,
    (part) => part.replace(HIGHLIGHT_PATTERN, `<mark${classAttribute}>$1</mark>`),
  )
}

/** Remove authored highlight delimiters while retaining their searchable text. */
export function stripMarkdownHighlightMarkers(markdown: string): string {
  return transformOutsideFencedCode(
    markdown,
    (part) => part.replace(HIGHLIGHT_PATTERN, '$1'),
  )
}
